import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type {
  CameraProps,
  PlaneTypes,
} from '@Components/BigBrowse/Model/ModelTypes';
import type {
  BrandConcessionContentDM,
  MultiSectionFigmaLayout,
  SectionItemDM,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/MultiSectionView.types';

export type Params = {
  modelData: BrandConcessionContentDM;
  cameraProps: CameraProps;
};

export type ViewData = {
  modelData: BrandConcessionContentDM;
  cameraProps: CameraProps;
  layoutTable?: GridCard<PlaneTypes>[][];
  columnWidth?: number;
  columnGap?: number;
  layoutWidth?: number;
  layoutHeight?: number;
};

export type ViewDataWithSection = ViewData & {
  section: SectionItemDM;
  layout: MultiSectionFigmaLayout;
};

export function initViewData({ modelData, cameraProps }: Params): ViewData {
  return { modelData, cameraProps };
}
